import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {StickyNavigationMenuActiveIndicatorBox} from "./boxes/sticky-navigation-menu-active-indicator/sticky-navigation-menu-active-indicator.box";
import {StickyNavigationMenuActiveIndicatorRailBox} from "./boxes/sticky-navigation-menu-active-indicator/sticky-navigation-menu-active-indicator-rail.box";

interface IStickyNavigationMenuActiveIndicatorComponentProps {
  position: number;
}

export class StickyNavigationMenuActiveIndicatorComponent extends OrbitComponent<IStickyNavigationMenuActiveIndicatorComponentProps> {

  render() {
    return (
      <StickyNavigationMenuActiveIndicatorRailBox>
        <StickyNavigationMenuActiveIndicatorBox position={this.props.position} />
      </StickyNavigationMenuActiveIndicatorRailBox>
    );
  }

}
